import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/http';
import { Notice, errorMessage } from '../../components/common';
import { t } from '../../i18n';
import { TimetableGrid, type Lesson, type Period } from './TimetableGrid';

/** The signed-in teacher's own week. */
export function MyTimetablePage() {
  const mine = useQuery({
    queryKey: ['me', 'timetable'],
    queryFn: () => api<{ periods: Period[]; entries: Lesson[] }>('/me/timetable'),
  });
  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('tt.mine')}</h1>
      {mine.isPending && <p role="status">{t('common.loading')}</p>}
      {mine.isError && <Notice kind="error">{errorMessage(mine.error)}</Notice>}
      {mine.data && mine.data.entries.length === 0 && (
        <p className="text-slate-600">{t('tt.empty')}</p>
      )}
      {mine.data && (
        <TimetableGrid periods={mine.data.periods} lessons={mine.data.entries} show="section" />
      )}
    </div>
  );
}
